<template>
  <div>
    <a-spin :spinning="isLoading">
      <div class="flex">
        <h2 class="text-2xl">Edit UGC Creators</h2>
      </div>
      <div class="grid grid-cols-6 gap-8">
        <div class="col-span-4">
          <Form v-model="form" v-model:mediaType="mediaType" />
        </div>

        <div class="col-span-5 flex justify-evenly pb-4">
          <button
            class="bg-red-500 hover:bg-red-700 text-white font-bold px-4 rounded flex items-center"
            @click="modalIsVisible = true"
          >
            Delete
          </button>
          <router-link to="/ugc-creators">
            <a-button>Cancel</a-button>
          </router-link>
          <a-button type="primary" @click="onSubmit">
            Save
          </a-button>
        </div>
      </div>
    </a-spin>
    <Modal
      v-model:isVisible="modalIsVisible"
      v-model:id="this.$route.params.id"
    />
  </div>
</template>

<script>
import Form from "@/components/Form/ugc-creator-form.vue";
import Modal from "@/components/Modals/DeleteUGCCreator";
import { ref, computed } from "vue";
import { useStore } from "vuex";

export default {
  components: { Form, Modal },
  async mounted() {
    const data = await this.$store.dispatch(
      "GET_UGC_CREATOR_BY_ID",
      this.$route.params.id
    );
    this.form = { ...this.form, ...data.data };
  },
  setup() {
    const store = useStore();

    const modalIsVisible = ref(false);

    const modal = computed(() => store.state.modalIsVisible);

    return { modalIsVisible, modal };
  },
  data() {
    return {
      isLoading: false,
      subindustries: null,
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      mediaType: "file",
      form: {
        name: null,
        country: null,
        profile_picture: null,
        videos: [],
      },
    };
  },
  methods: {
    async onSubmit() {
      const { success } = await this.updateUgcCreator();
      if (success) {
        this.$router.push("/ugc-creators");
      }
    },

    async updateUgcCreator() {
      this.isLoading = true;
      const ugc_creators = await this.$store.dispatch(
        "UPDATE_UGC_CREATORS",
        this.form
      );
      if (this.mediaType == "file") {
        const media = await this.uploadFile(ugc_creators.data.id);
        this.isLoading = false;
        return media;
      }
    },
    async uploadFile(id) {
      let formdata = new FormData();
      let sec_formdata = new FormData();

      if (
        this.form.profile_picture &&
        typeof this.form.profile_picture == "object"
      ) {
        sec_formdata.append("id", id);
        sec_formdata.append("folder", "UGC_Creators_Profile_Picture");
        sec_formdata.append("file", this.form.profile_picture);
        return await this.$store.dispatch(
          "UPLOAD_UGC_CREATORS_MEDIA_PROFILE",
          sec_formdata
        );
      }

      if (this.form.videos) {
        for (let i = 0; i <= 5; i++) {
          formdata.append("files", this.form.videos[i]);
        }
        formdata.append("id", id);
        formdata.append("folder", "UGC_Creators_Profile_Picture");
        return await this.$store.dispatch(
          "UPLOAD_UGC_CREATORS_MEDIA",
          formdata
        );
      }
    },
  },
};
</script>

<style scoped>
.advertisements__new__actions button ~ button,
.advertisements__new__actions a ~ a,
.advertisements__new__actions a ~ button,
.advertisements__new__actions button ~ a {
  margin-left: 10px;
}
.custom_select--group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 10px;
}
</style>
